import { Box, Typography } from '@mui/material';
import { ChartsLegend, DefaultizedPieValueType, PiePlot, pieArcLabelClasses } from '@mui/x-charts';
import { ResponsiveChartContainer } from '@mui/x-charts/ResponsiveChartContainer';
import { BoxWithHeader } from '../common';
import { DealerAccidentsOverviewProps } from './types';

export const RentalsByBranchPie = ({ graphData, date }: DealerAccidentsOverviewProps) => {
  const rentalsData = graphData?.totals?.rentalsByBranch;
  if (!rentalsData?.values?.length) return null;

  const pieData = rentalsData.values.map((item) => ({
    label: `${item.name} (${item.count})`,
    value: item.count,
    color: item.color
  }));

  const getArcLabel = (params: DefaultizedPieValueType) => {
    const item = rentalsData.values.find((v) => v.count === params.value);
    if (!item) return '';
    return `${item.percentage}%`;
  };

  return (
    <BoxWithHeader
      title={
        <>
          <Typography variant="h6" fontWeight="bold">
            Zapůjčená auta dle pobočky
          </Typography>
          <Typography variant="body2" color="gray">
            Počet zapůjčených aut dle pobočky ({date})
          </Typography>
          <Typography variant="body2" color="gray">
            Celkem zapůjčených aut: {rentalsData.count}
          </Typography>
        </>
      }
    >
      <Box width={1} height="425px">
        <ResponsiveChartContainer
          skipAnimation
          margin={{ bottom: 80 }}
          series={[
            {
              type: 'pie',
              data: pieData,
              arcLabel: getArcLabel
            }
          ]}
          sx={{
            [`& .${pieArcLabelClasses.root}`]: {
              fill: 'black',
              fontSize: 11
            }
          }}
        >
          <PiePlot />
          <ChartsLegend position={{ vertical: 'bottom', horizontal: 'middle' }} />
        </ResponsiveChartContainer>
      </Box>
    </BoxWithHeader>
  );
};
